import axios from '../../helpers/axios-setup';

export const impersonate = (login: string) => axios.post('/staff/impersonate', { login });
